import { CuboidVariants } from '@abyss/3d-viewer';
import { DEFAULT_CUBOID_COLOR } from '../cuboids/constants';

const generateStyle = (color: number) => ({
  style: {
    variant: CuboidVariants.LinesAndTransparentMesh,
    fillColor: color,
    fillOpacity: 0.1,
    lineColor: color,
    lineWidth: 2,
    lineOpacity: 0.8,
  },
  hoveredStyle: {
    variant: CuboidVariants.LinesAndTransparentMesh,
    fillColor: color,
    fillOpacity: 0.4,
    lineColor: color,
    lineWidth: 2,
    lineOpacity: 1,
  },
});

export const TOTAL_AREA_FIELD_FORMATTER: Record<string, string> = {
  area: 'Area',
  totalCorrodedArea: 'Total corroded area',
  ri4plusri5: 'Ri4 + Ri5',
};

export const CUSTOM_BLOCK_CUBOID_STYLES = {
  yellow: generateStyle(DEFAULT_CUBOID_COLOR),
  green: generateStyle(0x22C55E),
  blue: generateStyle(0x76CAFF),
  white: generateStyle(0xffffff),
};
